import(/* webpackMode: "eager" */ "/app/app/public/jobs/[slug]/error.tsx");
